module.exports = __webpack_public_path__ + "static/media/logo-stg.871985e5.svg";